import { HGMediaType, HGRecordMedia } from "@/common/types";
import { store } from "@/state/redux/store";
import { hgApi } from "./api";

export async function uploadRecordMedia(
  recordID: string,
  file: File,
  mediaType: HGMediaType,
  caption?: string,
): Promise<HGRecordMedia> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("media_type", mediaType);
  if (caption) {
    formData.append("caption", caption);
  }

  // No Content-Type header: the browser sets the multipart boundary itself
  const response = await fetch(`/api/records/${recordID}/media`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });

  if (!response.ok) {
    let detail = `Upload failed (${response.status})`;
    try {
      const body = await response.json();
      if (typeof body.detail === "string") {
        detail = body.detail;
      }
    } catch {
      // keep the default message
    }
    throw new Error(detail);
  }

  return response.json();
}

export async function deleteRecordMedia(recordID: string, mediaID: string) {
  const response = await fetch(`/api/records/${recordID}/media/${mediaID}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Failed to delete media (${response.status})`);
  }
}

export function invalidateRecordMedia(recordID: string) {
  store.dispatch(
    hgApi.util.invalidateTags([{ type: "HGRecordMedia", id: recordID }]),
  );
}
